export const PAGES = {
  "chi-siamo": {
    eyebrow: "Chi Siamo",
    title: "Comunicazione visiva, prodotta in casa.",
    metaTitle: "Chi Siamo | Nuova Giga Print Roma",
    metaDescription: "Nuova Giga Print crea e distribuisce prodotti che aiutano le aziende a presentare, valorizzare ed esporre il proprio marchio. Sedi a Roma.",
    img: "/img/company.webp",
    alt: "Reparto produttivo Nuova Giga Print con plotter e rotoli di materiale",
    lead: "L'azienda nasce con l'obiettivo di creare e distribuire prodotti che aiutino a presentare, valorizzare ed esporre un articolo o semplicemente il proprio logo aziendale.",
    blocks: [
      { title: "Cosa facciamo", points: ["Stampa su ogni tipologia di formato e supporto", "Allestimenti su misura", "Creatività e comunicazione", "Gadget personalizzati", "Digital Marketing, dal 2021"] },
      { title: "Come lavoriamo", points: ["La maggior parte degli articoli è prodotta nel nostro stabilimento", "Allestimento curato dai nostri collaboratori", "Collaborazione con i migliori partner sul mercato", "Controllo di qualità in tutte le fasi"] },
      { title: "Dove siamo", points: ["Roma — Via Giovanni Neper, 14", "00166 Roma"] },
    ],
    showStats: true,
  },
  prodotti: {
    eyebrow: "Prodotti",
    title: "Materiali moderni, sistemi su misura.",
    metaTitle: "Prodotti | PVC, alluminio, legno, plexiglass | Nuova Giga Print",
    metaDescription: "Sistemi espositivi su misura in PVC, alluminio, legno e plexiglass, gadget personalizzati, calendari, vetrofanie e pellicole. Prodotti a Roma.",
    img: "/img/letter-noon.webp",
    alt: "Lettering 3D illuminato su parete",
    lead: "Le tecnologie più avanzate ci permettono di progettare sistemi espositivi su misura con materiali moderni e innovativi.",
    blocks: [
      { title: "Materiali", points: ["PVC", "Alluminio, nelle sue varie finiture", "Legno", "Plexiglass"] },
      { title: "Prodotti", points: ["Lettering 3D in plexiglass", "Vetrofanie e pellicole adesive", "Banner e striscioni", "Calendari personalizzati", "Gadget con logo aziendale"] },
      { title: "Perché sceglierci", points: ["Produzione interna", "Macchinari da stampa e taglio di ultima generazione", "Rispetto dei tempi di consegna concordati"] },
    ],
  },
  stampe: {
    eyebrow: "Servizi Stampa",
    title: "Stampa di ogni tipo, su ogni supporto.",
    metaTitle: "Servizi Stampa | Digitale, offset, serigrafia | Nuova Giga Print",
    metaDescription: "Stampa digitale, offset, serigrafia e tampografia su qualunque supporto e formato. Grande formato, pellicole e banner a Roma.",
    img: "/img/hero-printer.webp",
    alt: "Plotter grande formato che stampa un banner",
    lead: "Dalla stampa digitale alla offset, dalla serigrafia alla tampografia: scegliamo con te la tecnica giusta per resa, quantità e tempi.",
    blocks: [
      { title: "Tecniche", points: ["Stampa digitale", "Stampa offset", "Serigrafia", "Tampografia"] },
      { title: "Applicazioni", points: ["Grande formato", "Banner e striscioni", "Pellicole adesive e vetrofanie", "Pellicole rifrangenti per mezzi", "Brochure, pieghevoli e calendari"] },
      { title: "Qualità", points: ["Macchinari di ultima generazione", "Controllo qualità in ogni fase", "Consegna nei tempi concordati"] },
    ],
  },
  allestimenti: {
    eyebrow: "Allestimenti",
    title: "L'allestimento giusto per ogni progetto.",
    metaTitle: "Allestimenti su misura per eventi e spazi | Nuova Giga Print",
    metaDescription: "Allestimenti per eventi, punti vendita e uffici: sistemi espositivi su misura, wrapping, vetrofanie e lettering 3D. Roma.",
    img: "/img/Allestimenti.webp",
    alt: "Allestimento evento outdoor con bandiere e desk",
    lead: "Il nostro team è specializzato nell'offrire e realizzare l'allestimento più adatto a ogni tipo di progetto, dalla progettazione alla posa.",
    blocks: [
      { title: "Cosa allestiamo", points: ["Eventi e manifestazioni", "Punti vendita e vetrine", "Uffici e spazi aziendali", "Mezzi e flotte (wrapping)"] },
      { title: "Soluzioni", points: ["Sistemi espositivi su misura", "Lettering 3D in plexiglass", "Vetrofanie e pellicole", "Bandiere, desk e strutture brandizzate"] },
      { title: "Il metodo", points: ["Progettazione su misura", "Produzione interna", "Posa a cura dei nostri collaboratori"] },
    ],
  },
  marketing: {
    eyebrow: "Digital Marketing",
    title: "Dal 2021, anche online.",
    metaTitle: "Digital Marketing | Siti web, Google My Business | Nuova Giga Print",
    metaDescription: "Il team Marketing e Comunicazione di Nuova Giga Print offre creazione siti web, gestione profili Google My Business e analisi dei dati.",
    img: "/img/design-desk.webp",
    alt: "Postazione di lavoro con monitor per progetti digitali",
    lead: "Grazie al nostro team di Marketing e Comunicazione, dal 2021 portiamo la tua immagine anche sul digitale.",
    blocks: [
      { title: "Creazione siti web", points: ["Progettazione e grafica coerenti con il brand", "Ottimizzazione per smartphone"] },
      { title: "Google My Business", points: ["Apertura e gestione dei profili", "Informazioni e foto sempre aggiornate"] },
      { title: "Analisi dei dati", points: ["Lettura dei risultati", "Indicazioni concrete per migliorare"] },
    ],
  },
  press: {
    eyebrow: "Press",
    title: "Dicono di noi.",
    metaTitle: "Press | Nuova Giga Print su RomaToday",
    metaDescription: "L'intervista di RomaToday del 30/04/2020 a Nuova Giga Print sulle soluzioni in plexiglass anti-Covid per lavorare in sicurezza.",
    img: "/img/letter-studio.webp",
    alt: "Lettering in rilievo su parete",
    lead: "Durante il lockdown ci siamo rinnovati, trovando soluzioni veloci per permettere alle aziende di lavorare in sicurezza.",
    blocks: [],
    showPress: true,
  },
  creativita: {
    eyebrow: "Creatività",
    title: "Creatività & Graphic Design.",
    metaTitle: "Creatività e Graphic Design | Nuova Giga Print",
    metaDescription: "Consulenza di Creatività & Graphic Design per la stampa e per applicazioni digitali. Nuova Giga Print, Roma.",
    img: "/img/creativita-gigaprint.webp",
    alt: "Pieghevole con grafica tipografica",
    lead: "Curiamo la consulenza di Creatività & Graphic Design sia per la stampa sia per le applicazioni digitali.",
    blocks: [
      { title: "Per la stampa", points: ["Brochure e pieghevoli", "Calendari", "Grafiche per allestimenti e vetrofanie"] },
      { title: "Per il digitale", points: ["Grafiche per siti web", "Contenuti per i canali social"] },
      { title: "Il vantaggio", points: ["Un unico interlocutore dall'idea alla produzione"] },
    ],
  },
  gadget: {
    eyebrow: "Gadget personalizzati",
    title: "Il tuo logo, sugli oggetti di tutti i giorni.",
    metaTitle: "Gadget personalizzati con logo | Nuova Giga Print",
    metaDescription: "Gadget personalizzati con il logo aziendale: penne, cappellini, chiavette USB, bandiere, calendari. Nuova Giga Print Roma.",
    img: "/img/gadget-gigaprint.webp",
    alt: "Gadget personalizzati con logo",
    lead: "Gadget aziendali che portano il tuo marchio in ufficio, agli eventi e nelle mani dei clienti.",
    blocks: [
      { title: "Esempi", points: ["Penne", "Cappellini", "Chiavette USB", "Bandiere da tavolo", "Calendari personalizzati"] },
      { title: "Per chi", points: ["Eventi e fiere", "Regali aziendali", "Kit di benvenuto"] },
    ],
  },
};
